<app-alert [alertType]="'error'" (closeClick)="closeClick.emit()">
  @if (errorTranslationKey) {
    <span [innerHTML]="errorBodyTranslation | translate: { action: buildAction(), error: buildError() }"></span>

    @if (redirectAction) {
      &nbsp;<span [innerHTML]="(objectBodyTranslation | translate: { object: buildObjectLink() })"></span>
    }
  } @else {
    <span [innerHTML]="errorBodyTranslation | translate: { action: buildAction() }"></span>

    @if (redirectAction) {
      &nbsp;<span [innerHTML]="(objectBodyTranslation | translate: { object: buildObjectLink() })"></span>
    }
  }
</app-alert>
